export default __webpack_public_path__ + "static/media/Attendenceimage.ed442e0a.png";